import { render, staticRenderFns } from "./ConfirmTransferRequest.vue?vue&type=template&id=776c9366"
import script from "./ConfirmTransferRequest.vue?vue&type=script&lang=js"
export * from "./ConfirmTransferRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports